import React from 'react';

import { colorsSelector } from '@redux/colorPalette/selectors';
import { useSelector } from 'react-redux';

import B2bPlayerArea from 'components/b2b/B2bPlayerArea';

import { PlayerAreaContainer } from './Player.style';

const Player: React.FunctionComponent = () => {
  const colors = useSelector(colorsSelector);
  return (
    <PlayerAreaContainer {...{ colors }}>
      <B2bPlayerArea />
    </PlayerAreaContainer>
  );
};

export default Player;
